import * as React from "react";

import type * as m from "../../model/model";

export type FeatureAvailabilityContextValue = m.Config.FeatureAvailabilityConfig;

export const defaultFeatureAvailability: FeatureAvailabilityContextValue = {
	Country: "SE",
	RotRut: true,
	Salary: true,
	VatCheck: true,
	ReversedVAT: true,
	InvoiceRounding: true,
	SIE: true,
	Plaid: false,
	ImportantDates: true,
	TrialBalance: false,
	PartnerServiceK10: true,
	YearEndClosureSE: true,
	PrioSupport: true,
	FindAnAccountant: false,
	Billing: false,
	Plans: true,
	Cashback: true,
	BGFiles: true,
	NoMoneyTemplates: false,
	RequireCountrySubdivisionForBookkeeping: false,
	CreateCustomAccounts: true,
	Stripe: false,
	Factoring: false,
	BokioBusinessAccount: false,
	Klarna: false,
	EnableBanking: false,
	SalaryFullPaymentSubmissions: false,
	EInvoice: true,
	BookkeepingSupport: false,
	Drilldown: false,
	SkatteverketSync: false,
	PublicApi: true,
	PublicApiIntegrationMarketplace: true,
	AiFeatures: true,
	AllowNewSignups: true,
};

// The context provider is implemented differents for web and mobile since web use it from window and mobile use mobx
export const FeatureAvailabilityContext =
	React.createContext<FeatureAvailabilityContextValue>(defaultFeatureAvailability);

// If you change name of "useFeatureAvailibility" here
// Make sure to update the jest.spyOn(featureAvailabilityContext, "useFeatureAvailibility") in MobileApp and n folder too
export const useFeatureAvailability = () => React.use(FeatureAvailabilityContext);
